export function resetData(componentDataReference, initialStateFunction) {
	const initialData = initialStateFunction();

	for (const key in initialData){
		if (initialData.hasOwnProperty(key)){
			componentDataReference[key] = initialData[key];
		}
	}
}